import { ActionTree } from 'vuex'

import { MatchedState, RootState } from '@/types/store'

import {
  deleteMatched,
  deleteMatchedByName,
  getMatcheds,
  updateMatched,
  updateMatchedByName,
  updateMatchedByIds,
} from '@/api/matcheds'
import { IMatched } from '@/types/matched'

export const actions: ActionTree<MatchedState, RootState> = {
  async getMatcheds(
    { commit },
    {
      createdAtStart,
      createdAtEnd,
      code,
      targetName,
      isTargetNamePerfectMatch,
      targetOcr,
      isTargetOcrPerfectMatch,
      categoryId,
      isToBeDeleted,
      isApproved,
      suggestName,
    }: {
      createdAtStart: string
      createdAtEnd: string
      code: string
      targetName: string
      isTargetNamePerfectMatch: boolean
      targetOcr: string
      isTargetOcrPerfectMatch: boolean
      categoryId: number
      isToBeDeleted: boolean
      isApproved: boolean
      suggestName: string
    },
  ): Promise<void> {
    commit('matchedsLoaded', { item: [], total: 0 })
    commit('matchedsLoadStart', true)
    const matcheds = await getMatcheds(
      createdAtStart,
      createdAtEnd,
      code,
      targetName,
      isTargetNamePerfectMatch,
      targetOcr,
      isTargetOcrPerfectMatch,
      categoryId,
      isToBeDeleted,
      isApproved,
      suggestName,
    )
    commit('matchedsLoaded', matcheds)
  },
  async updateMatched(
    { commit },
    { id, matched }: { id: string; matched: IMatched },
  ): Promise<void> {
    await updateMatched(id, matched)
    commit('matchedUpdated', { id, matched })
  },
  async updateMatchedByName(
    { commit },
    { name, matched }: { name: string; matched: IMatched },
  ): Promise<void> {
    await updateMatchedByName(name, matched)
    commit('matchedUpdatedByName', { name, matched })
  },
  async updateMatchedByIds(
    { commit },
    { ids, matched }: { ids: string[]; matched: IMatched },
  ): Promise<void> {
    await updateMatchedByIds(ids, matched)
    commit('matchedUpdatedByIds', { ids, matched })
  },
  async matchedUpdated(
    { commit },
    { id, matched }: { id: number; matched: IMatched },
  ): Promise<void> {
    commit('matchedUpdated', { id, updated: matched })
  },
  async deleteMatched({ commit }, id: string): Promise<void> {
    await deleteMatched(id)
    commit('matchedDeleted', id)
  },
  async deleteMatchedByName({ commit }, name: string): Promise<void> {
    await deleteMatchedByName(name)
    commit('matchedDeletedByName', name)
  },
  reset({ commit }): void {
    commit('matchedsLoaded', { item: [], total: 0 })
  },
}
